import { Feather, MaterialIcons } from "@expo/vector-icons";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Dimensions, Text, TouchableOpacity, View } from "react-native";
import Collapsible from "react-native-collapsible";
import colors from "../constants/colors";
import Row from "./Row";
import { normalize } from "../utils/normalize";
import { useSelector } from "react-redux";
// TODO: add isSpecialist
const Catergories = (props) => {
  const { isDoctor } = useSelector((state) => state.user);
  let allData = props.data?.length > 0 ? props.data : Array.from(Array(4).keys());
  let allCategories =
    isDoctor || props.isDoctor
      ? allData
        .slice()
        .sort((a, b) => a.doctor_title?.localeCompare(b.doctor_title))
      : allData;

  let selected = props.selected || [];
  const [showSection, setShowSection] = useState(true);
  const [showChildren, setShowChildren] = useState([]);
  const [selectedChildren, setSelectedChildren] = useState([]);
  useEffect(() => {
    if (props.filterText?.length > 0) {
      setShowSection([0, 1]);
    } else {
      if (props.startCollapse) {
        if (!props.filterText) setShowSection([]);
      }
    }
  }, [props.filterText]);

  const onSelectChildren = (category) => {
    if (selectedChildren.includes(category.slug)) {
      setSelectedChildren(
        selectedChildren.filter((val) => val !== category.slug)
      );
    } else {
      setSelectedChildren([...selectedChildren, category.slug]);
    }
  };
  const convertTitle = (title) => {
    if (props?.expertise === 3 && title === "General Dentist")
      return "General Dentist";
    if ([3, 2].includes(props?.expertise) && title === "Specialist")
      return "Dental Specialist";
    return title;
  };
  const convertName = (category) => {
    if (props?.expertise === 3) {
      let n = (category?.name + " ")
        .replaceAll("Dentist ", "")
        .replace("Dentistry ", "")
        .replace("- ", "");

      return n + "Dental Assistant";
    } else if (props?.isDoctor) {
      if (
        props.expertise === 101 &&
        category?.doctor_title !== "General Practitioner"
      ) {
        return category?.doctor_title;
      } else return category?.doctor_title;
    } else {
      return category?.name;
    }
  };
  const list = allCategories
    ?.filter((val) => {
      if (props?.filterList) {
        return props.filterList.includes(val.slug);
      } else return true;
    })
    ?.filter((val) => {
      if (props.filterText && props.filterText.length > 0) {
        // Check if the main category name matches
        const mainCategoryMatch = val.name
          .toLowerCase()
          .includes(props.filterText.toLowerCase());

        // Check if any children match the filter text
        const childrenMatch = val.children && val.children.some(child =>
          child.name.toLowerCase().includes(props.filterText.toLowerCase())
        );

        return mainCategoryMatch || childrenMatch;
      } else {
        return true;
      }
    })
  if (list?.length === 0) return null;

  return (
    <>
      {props.hideLabel ? null : (
        <TouchableOpacity
          onPress={() => {
            setShowSection(!showSection);
          }}
        >
          <View
            style={{
              marginTop: 14,
              marginLeft: props.isShowAll ? 0 : props.isCheckbox ? 10 : 20,
              alignItems: props.isShowAll ? "center" : "flex-start",
            }}
          >
            {props.isShowAll ? <View style={styles.line} /> : null}

            <Row centered>
              {props.isShowAll ? null : (
                <Feather
                  name={`chevron-${showSection ? "down" : "up"}`}
                  size={20}
                />
              )}
              <Text
                style={{
                  margin: 4,
                  paddingHorizontal: 10,
                  backgroundColor: props.isShowAll ? "white" : "transparent",
                  marginTop: props.isShowAll ? -9 : 4,
                  fontWeight: "bold",
                  textAlign: "center",
                  color: "rgba(0,0,0,0.8)",
                }}
              >
                {convertTitle(props.title)}
              </Text>
            </Row>
          </View>
        </TouchableOpacity>
      )}
      <Collapsible collapsed={props.isShowAll ? false : !showSection}>
        <View
          {...props}
          style={{
            ...styles.categoryContainer,
            ...props.style,
            marginHorizontal: props.hideLabel ? 0 : 10,
            flexDirection: props.isCheckbox ? "column" : "row",
            flexWrap: props.isCheckbox ? "nowrap" : "wrap",
            marginVertical: props.isCheckbox ? 8 : 24,
          }}
        >
          {list?.map((category, index) => {
              if (props.category) {
                if (props.category !== category.category) return;
              }
              let checkboxStyles = props.isCheckbox
                ? {
                  borderColor: "transparent",
                  backgroundColor: selected.includes(category.slug)
                    ? "rgb(233,237, 250)"
                    : "transparent",
                  marginVertical: 2,
                }
                : {};
              return (
                <View key={category.slug || index} style={{ width: props.isShowAll && !props.isCheckbox ? 'auto' : '100%' }}>
                  <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <TouchableOpacity
                      style={{
                        flex: props.isShowAll && !props.isCheckbox ? 0 : 1,
                        display: "flex",
                      }}
                      onPress={() => {
                        if (category?.children?.length > 0) {
                          setShowChildren(showChildren.filter((val) => val !== category.slug));

                          if (showChildren.includes(category.slug)) {
                            props.onPress(
                              category.slug,
                              category?.children,
                              convertName(category)
                            );
                            onSelectChildren(category);
                          } else {
                            props.onPress(
                              category.slug,
                              category?.children,
                              convertName(category)
                            );
                            // setShowChildren([...showChildren, category.slug]);
                          }
                        } else {
                          props.onPress(
                            category.slug,
                            null,
                            convertName(category)
                          );
                        }
                      }}
                    >
                      <View
                        style={{
                          ...styles.category,
                          marginHorizontal: props.hideLabel ? 0 : 6,
                          backgroundColor: selected.includes(category.slug)
                            ? "#f5f5f5"
                            : "#eee",
                          borderColor: selected.includes(category.slug)
                            ? colors.primary
                            : "transparent",

                          borderRadius: props.isCheckbox ? 10 : 100,
                          ...checkboxStyles,
                        }}
                      >
                        <Row centered>
                          {props.isCheckbox ? (
                            <View style={{ marginRight: 10, marginLeft: -10 }}>
                              <MaterialIcons
                                name={
                                  selected.includes(category.slug)
                                    ? "check-box"
                                    : "check-box-outline-blank"
                                }
                                size={20}
                                color={
                                  selected.includes(category.slug)
                                    ? "rgb(72, 92, 242)"
                                    : "rgba(0,0,0,0.2)"
                                }
                              />
                            </View>
                          ) : null}
                          <Text
                            style={{
                              color: "rgba(0,0,0,0.8)",
                              fontWeight: props.isCheckbox ? "regular" : "bold",
                              fontSize: props.isCheckbox
                                ? normalize(14)
                                : normalize(12),
                              margin: props?.isCheckbox ? 4 : 0,
                            }}
                          >
                            {convertName(category)}
                          </Text>
                        </Row>
                      </View>
                    </TouchableOpacity>
                    {category?.children?.length > 0 && (
                      <TouchableOpacity onPress={() => {
                        if (showChildren.includes(category.slug)) {
                          setShowChildren(showChildren.filter((val) => val !== category.slug));
                        } else {
                          setShowChildren([...showChildren, category.slug]);
                        }
                      }}>
                        <MaterialIcons name={showChildren.includes(category.slug) ? "keyboard-arrow-up" : "keyboard-arrow-down"} size={24} color="black" style={{ marginLeft: 10 }} />
                      </TouchableOpacity>
                    )}
                  </View>
                  <Collapsible
                    collapsed={
                      !props.filterText?.length > 0 &&
                      (props.isCheckbox
                        ? !showChildren.includes(category.slug)
                        : false)
                    }
                  >
                    <View
                      style={{
                        flexDirection: props.isCheckbox ? "column" : "row",
                        flexWrap: props.isCheckbox ? "nowrap" : "wrap",
                      }}
                    >
                      {category.children && category.children.length > 0
                        ? category.children.filter((subcategory) => subcategory.name.toLowerCase().includes(props.filterText.toLowerCase())).map((subcategory, subIndex) => {
                          let subCheckboxStyle = props.isCheckbox
                            ? {
                              borderColor: "transparent",
                              backgroundColor: selected.includes(
                                subcategory.slug
                              )
                                ? "rgb(233,237, 250)"
                                : "transparent",
                              marginVertical: 2,
                            }
                            : {};
                          return (
                            <TouchableOpacity
                              key={subIndex}
                              onPress={() => {
                                props.onPress(
                                  subcategory.slug,
                                  null,
                                  convertName(category)
                                );
                                onSelectChildren(category);
                              }}
                            >
                              <View
                                style={{
                                  marginLeft: props.isCheckbox ? 32 : 0,
                                  ...styles.category,
                                  backgroundColor: selected.includes(
                                    subcategory.slug
                                  )
                                    ? "#f5f5f5"
                                    : "#eee",
                                  borderColor: selected.includes(
                                    subcategory.slug
                                  )
                                    ? colors.primary
                                    : "transparent",
                                  width: props.isCheckbox
                                    ? Dimensions.get("window").width > 780
                                      ? 674
                                      : Dimensions.get("window").width - 106
                                    : "auto",
                                  borderRadius: props.isCheckbox ? 10 : 100,
                                  ...subCheckboxStyle,
                                }}
                              >
                                <Row centered>
                                  {props.isCheckbox ? (
                                    <View
                                      style={{
                                        marginRight: 10,
                                        marginLeft: -10,
                                      }}
                                    >
                                      <MaterialIcons
                                        name={
                                          selected.includes(subcategory.slug)
                                            ? "check-box"
                                            : "check-box-outline-blank"
                                        }
                                        size={20}
                                        color={
                                          selected.includes(subcategory.slug)
                                            ? "rgb(72, 92, 242)"
                                            : "rgba(0,0,0,0.2)"
                                        }
                                      />
                                    </View>
                                  ) : null}
                                  <Text
                                    style={{
                                      color: "rgba(0,0,0,0.8)",
                                      fontWeight: props.isCheckbox
                                        ? "regular"
                                        : "bold",
                                      fontSize: props.isCheckbox
                                        ? normalize(14)
                                        : normalize(12),
                                      margin: props?.isCheckbox ? 4 : 0,
                                    }}
                                  >
                                    {props?.isDoctor
                                      ? subcategory?.doctor_title
                                      : subcategory?.name}
                                  </Text>
                                </Row>
                              </View>
                            </TouchableOpacity>
                          );
                        })
                        : null}
                    </View>
                  </Collapsible>
                </View>
              );
            })}
        </View>
      </Collapsible>
    </>
  );
};

Catergories.PropTypes = {
  label: PropTypes.string,
  style: PropTypes.object,
};

const styles = {
  categoryContainer: {
    marginHorizontal: 10,
    justifyContent: "center",
  },
  category: {
    padding: 8,
    margin: 6,
    paddingHorizontal: 24,
    borderWidth: 1,
  },
  line: {
    zIndex: -1,
    width: "90%",
    height: 1,
    backgroundColor: "rgba(0,0,0,0.2)",
  },
};

export default Catergories;
